<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="closeDialog()" @keydown.esc="closeDialog()" fullscreen transition="dialog-bottom-transition">
      <v-card>
        <v-form ref="form" v-on:submit.prevent="importar($event)">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text style="margin-bottom: 80px">
            <v-row align="start" justify="center" transition="fade-transition">
              <v-col md="10" class="mt-4 pr-0 pl-0">
                <v-form ref="form_step1">
                  <div class="px-2 py-1 mb-3 bg-subtitle-section">
                    <p class="text-subtitle-1 mb-0">
                      <b>Sincronización</b>
                    </p>
                  </div>
                  <v-progress-linear v-model="percent" color="blue-grey" style="height: 25px !important" class="mb-3 mt-3">
                    <strong>{{ Math.ceil(percent) || 0 }}%</strong>
                  </v-progress-linear>

                  <v-row v-if="importaciones_no_creadas > 0" class="mb-3">
                    <v-col cols="12">
                      <v-checkbox
                        v-model="show_only_failed"
                        density="comfortable"
                        label="Mostrar solo fallidas"
                        hide-details
                        color="error"
                      ></v-checkbox>
                    </v-col>
                  </v-row>

                  <v-data-table 
                    :headers="headers" 
                    :items="filteredListBulk" 
                    :search="search" 
                    :loading="loading_table" 
                    class="expandable-rows" 
                    :items-per-page="10"
                    :items-per-page-options="[5, 10, 25, 50, 100]"
                    
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          <div class="font-weight-medium" :style="item.object.wave != null ? 'margin-top: 5px; margin-bottom: -5px' : ''">
                            {{ item.object.code }}
                          </div>
                          <span class="text-caption text-grey-600">{{ item.object.wave != null ? "Ola " + item.object.wave.id : "" }}</span>
                        </td>
                        <td>{{ item.object.date }}</td>
                        <td>{{ item.object.canal_venta_name != null ? item.object.canal_venta_name : "-" }}</td>
                        <td>{{ item.object.document_type_name }}</td>
                        <td>{{ item.object.client_user_name }}</td>
                        <td>{{ item.object.address + ", " + item.object.location }}</td>
                        <td>{{ item.object.external_reference }}</td>

                        <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.msg == '' && !item.status_create">
                          <i class="fa fa-check text-green"></i>
                        </td>
                        <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.msg != '' && !item.status_create">
                          <span class="text-red">{{ item.msg }}</span>
                        </td>
                        <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.status_create">
                          <span class="text-green">Sincronizado</span>
                        </td>
                        <td style="min-width: 200px" v-if="!item.loading && item.status == 0">
                          {{ "Pendiente de procesado" }}
                        </td>
                        <td style="min-width: 200px" v-if="item.loading">Procesando...</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions style="position: fixed; bottom: 0; right: 0; left: 0">
            <v-row align="start" justify="center">
              <v-col cols="10" style="background-color: white">
                <div class="float-right mr-2">
                  <v-chip color="success" class="mr-2">Sincronizadas: {{ importaciones_creadas }}</v-chip>
                  <v-chip color="error" class="">Fallidas: {{ importaciones_no_creadas }}</v-chip>
                </div>
              </v-col>
              <v-col cols="12" style="background-color: #fafafa; border-top: 1px solid #c1c1c1" class="text-end">
                <v-btn color="error" text @click="closeDialog()">Cerrar</v-btn>
                <v-btn color="success" text type="submit" :disabled="submit_disabled" :loading="loading">{{ formBtn }}</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";
import UserTypeConstant from "@/constants/user_type";

export default {
  components: {},
  mixins: [ValidMixin],
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    editItem: Object,
    selectedItems: Array,
  },
  data() {
    return {
      show: false,
      disabled: false,
      loading: false,
      headers: [
        {
          title: "Numero",
          align: "left",
          sortable: true,
          key: "code",
        },
        {
          title: "Fecha",
          align: "left",
          sortable: true,
          key: "date",
        },
        {
          title: "Canal de Venta",
          align: "left",
          sortable: true,
          key: "canal_venta.name",
        },
        {
          title: "Tipo de Documento",
          align: "left",
          sortable: true,
          key: "document_type.name",
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          key: "client.user.username",
          visible_for_client: false,
        },
        {
          title: "Destino",
          align: "left",
          sortable: true,
          key: "receiver",
        },
        {
          title: "Ref. Externa",
          align: "left",
          sortable: true,
          key: "external_reference",
        },
        {
          title: "Resultado",
          align: "left",
          sortable: false,
          key: "msg",
        },
      ],
      list_bulk: [],
      loading_create: false,
      importaciones_creadas: 0,
      importaciones_no_creadas: 0,
      total_importaciones: 0,
      progress: 0,
      loading_table: false,
      submit_disabled: false,
      search: "",
      show_only_failed: false,
      userTypeConstant: UserTypeConstant,
      user_type: null,
    };
  },
  watch: {
    selectedItems: {
      handler(newItems) {
        this.initializeOrders(newItems);
      },
      immediate: true,
    },
    dialog(newVal) {
      if (newVal) {
        this.resetCounters();
      }
    },
  },
  mounted() {
    this.user_type = localStorage.getItem("user_type");
    if (this.selectedItems && this.selectedItems.length > 0) {
      this.initializeOrders(this.selectedItems);
    }
  },

  computed: {
    percent: {
      get() {
        return ((this.getProcesadosValidos() + this.getProcesadosNoValidos()) * 100) / this.list_bulk.length;
      },
      set(value) {
        return value;
      },
    },
    filteredListBulk() {
      if (!this.show_only_failed) {
        return this.list_bulk;
      }
      // Mostrar solo las que fallaron (status == 1 y status_create == false)
      return this.list_bulk.filter(
        (item) => item.status === 1 && !item.status_create
      );
    },
  },

  methods: {
    initializeOrders(items) {
      this.list_bulk = items.map((item) => ({
        object: item,
        msg: "",
        status: 0,
        status_create: false,
        loading: false,
      }));
      this.total_importaciones = this.list_bulk.length;
    },
    resetCounters() {
      this.importaciones_creadas = 0;
      this.importaciones_no_creadas = 0;
      this.loading_create = false;
      this.submit_disabled = false;
      this.show_only_failed = false;

      // Reset all orders to pending status
      this.list_bulk.forEach((order) => {
        order.status = 0;
        order.status_create = false;
        order.loading = false;
        order.msg = "";
      });
    },
    getProcesadosValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && element.status_create).length;
    },
    getProcesadosNoValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && !element.status_create).length;
    },

    closeDialog() {
      this.$emit("update:dialog", false);
      this.$emit("loadList");
      this.resetCounters();
      this.list_bulk = [];
    },

    async importar() {
      var index = 0;
      this.loading_create = true;
      this.submit_disabled = true;

      for (const element of this.list_bulk) {
        if (this.list_bulk[index].msg == "" && !this.list_bulk[index].status_create && this.list_bulk[index].status == 0) {
          this.list_bulk[index].loading = true;
          let result = await this.createItem(this.list_bulk[index].object);

          console.log("result", result);
          this.list_bulk[index].loading = false;
          this.list_bulk[index].status = 1;
          this.list_bulk[index].status_create = result.status;
          this.list_bulk[index].msg = result.msg;

          if (result.status) {
            this.importaciones_creadas++;
          } else {
            this.importaciones_no_creadas++;
          }
        }

        index++;
      }

      this.loading_create = false;

      if (this.importaciones_creadas === this.list_bulk.length) {
        this.$emit("update:dialog", false);
        this.list_bulk = [];
        this.$emit("loadList");
      }
    },
    async createItem(item) {
      try {
        const response = await this.service.sync_shipment_in_tms(item.id);
        if (response.status) {
          return {
            status: response.status,
            msg: response.msg || "Sincronizado correctamente",
          };
        } else {
          return {
            status: response.status,
            msg: response?.msg || "Error en la sincronización",
          };
        }
      } catch (error) {
        console.error("Error syncing order:", error);
        let errorMessage = "Error de conexión";
        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        return {
          status: false,
          msg: errorMessage,
        };
      }
    },
  },
};
</script>
